import { render, staticRenderFns } from "./Inside.vue?vue&type=template&id=af53ec46&scoped=true&"
import script from "./Inside.vue?vue&type=script&lang=js&"
export * from "./Inside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af53ec46",
  null
  
)

export default component.exports